import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver';
import { CanvasECGPath } from './CanvasECGRenderPath';
export function createDefaultECGRenderPaths() {
    return [new CanvasECGPath()];
}
export function createECGRenderPathResolver(paths = createDefaultECGRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
